import './_header-styles.scss';
import { Header } from './Header';
import resizeManager from './ResizeManager';

window.addEventListener( 'load', () => {

	const header = new Header();

	resizeManager.addListener( header.onResize.bind( header ) );

} );
